import { ObservableArray, View } from "binder"
import { DriverSelectorViewModel, SendFormItem, SendFormViewModel } from "./sendForm-viewModel"

export class SendFormView extends View<SendFormViewModel>{
    GetViewUniqueId(): string {
        return "V-93F75D46-D2C1-4393-8B99-5F956769ECCE"
    }
    loadHtml(): string {
        let element = require('./sendForm.html').default;
        let style = require('./sendForm.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    public set sendFormItems(v: ObservableArray<SendFormItem>) { this._sendPackageProducts = v; } public get sendFormItems(): ObservableArray<SendFormItem> { return this._sendPackageProducts; } private _sendPackageProducts: ObservableArray<SendFormItem>;
    public set driverId(v: string) { this._driverId = v; } public get driverId(): string { return this._driverId;} private _driverId: string;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName; } private _driverName: string;
    public set driverFirstName(v: string) { this._driverFirstName = v; } public get driverFirstName(): string { return this._driverFirstName;} private _driverFirstName: string;
    public set driverLastName(v: string) { this._driverLastName = v; } public get driverLastName(): string { return this._driverLastName;} private _driverLastName: string;
    public set driverPhone(v: string) { this._driverPhone = v; } public get driverPhone(): string { return this._driverPhone;} private _driverPhone: string;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set carType(v: string) { this._carType = v; } public get carType(): string { return this._carType;} private _carType: string;
    public set exitFormNumber(v: string) { this._exitFormNumber = v; } public get exitFormNumber(): string { return this._exitFormNumber;} private _exitFormNumber: string;
    public set driverSelector(v: DriverSelectorViewModel) { this._driverSelector = v; } public get driverSelector(): DriverSelectorViewModel { return this._driverSelector;} private _driverSelector: DriverSelectorViewModel;
    public set canSend(v: boolean) { this._canSend = v; } public get canSend(): boolean { return this._canSend;} private _canSend: boolean;

    createOrUpdateDriver() {
        this.dataContext.createOrUpdateDriver();
    }

    closePopup() {
        this.dataContext.close_popup();   
    }
     
    send() {
        this.dataContext.send();
    }
}
